document.addEventListener('DOMContentLoaded', function () {
  function initializeSplideForActiveCarousels() {
    document.querySelectorAll('.section-tab-switch.active-carousel').forEach((splideElement) => {
      if (!splideElement.classList.contains('splide-initialized')) {
        const prodCardQty =  parseInt(splideElement.dataset.prodCardQty, 10) || 0;
        const splideInstance = new Splide(splideElement, {
          perPage: 4,
          gap: '2rem',
          arrows: prodCardQty > 4,
          pagination: prodCardQty > 4,
          classes: {
            pagination: "splide__pagination custom-pagination",
            page: "splide__pagination__page custom-dot",
            arrows: "custom-splide-arrow", 
          },
          breakpoints: {
            900: {
              perPage: 2.3,
              arrows: prodCardQty > 2.3,
              pagination: prodCardQty > 2.3,
            },
            500: {
              perPage: 2,
              gap: '1rem',
              arrows: false,
              pagination: prodCardQty > 2,

            }
          }
        }).mount();

        splideElement.splideInstance = splideInstance;
        splideElement.classList.add('splide-initialized', 'is-initialized');
      }
    });
  }

  function destroySplideForInactiveCarousels() {
    document.querySelectorAll('.section-tab-switch.inactive-carousel').forEach((splideElement) => {
      if (splideElement.classList.contains('splide-initialized') && splideElement.splideInstance) {
        splideElement.splideInstance.destroy(true);
        delete splideElement.splideInstance;
        splideElement.classList.remove('splide-initialized', 'is-initialized');
      }
    });
  }

  initializeSplideForActiveCarousels();

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('section-tab-switch')) {
          if (target.classList.contains('active-carousel')) {
            initializeSplideForActiveCarousels();
          } else if (target.classList.contains('inactive-carousel')) {
            destroySplideForInactiveCarousels();
          }
        }
      }
    });
  });

  document.querySelectorAll('.section-tab-switch').forEach((element) => {
    observer.observe(element, { attributes: true });
  });
});
